import React, { useState, useEffect, useCallback, useImperativeHandle } from 'react';
import { Button, withTheme } from '@rneui/themed';
import { useUserUUID } from '@annunciate/core';
import { FAIcon } from '../elements';
import { useTagsQuery, useTagCreateMutation, useTagItemDeleteMutation, } from '@annunciate/query';
export const UnthemedFavoriteButton = React.forwardRef(({ item, iconStyle = {}, size = 30, isLeftAligned, isRightAligned, color, activeColor, }, ref) => {
    const uuid = useUserUUID();
    const [tagItemId, setTagItemId] = useState();
    const { mutateAsync: create } = useTagCreateMutation();
    const { mutateAsync: remove } = useTagItemDeleteMutation();
    const { data, refetch } = useTagsQuery();
    const key = data?.reduce((acc, tag) => {
        const itemIds = tag?.items?.map(({ id }) => id).join(',');
        return `${acc}-tag${tag.id}items${itemIds}`;
    }, '');
    const toggleFavorite = useCallback(async () => {
        if (tagItemId === undefined) {
            try {
                await create({
                    name: '❤️',
                    item: {
                        entityId: item.id,
                        entityType: item.__typename,
                    },
                });
                await refetch();
            }
            catch (e) {
                console.error(e);
            }
        }
        else {
            await remove({ id: tagItemId });
            setTagItemId(undefined);
        }
    }, [
        tagItemId,
        item?.id,
    ]);
    useEffect(() => {
        if (data) {
            const favorite = data.find(({ name }) => name === '❤️');
            const exists = favorite?.items?.find(({ entityId, entityType, }) => entityId === item?.id && entityType === item?.__typename);
            setTagItemId(exists?.id);
        }
    }, [item?.id, key]);
    useImperativeHandle(ref, () => {
        return { toggle: toggleFavorite };
    }, [toggleFavorite]);
    if (!uuid) {
        return null;
    }
    const isActive = tagItemId !== undefined;
    return (React.createElement(Button, { type: "clear", onPress: toggleFavorite, isLeftAligned: isLeftAligned, isRightAligned: isRightAligned },
        React.createElement(FAIcon, { name: "heart", color: isActive ? activeColor : color, solid: tagItemId !== undefined, size: size, style: iconStyle })));
});
export const FavoriteButton = withTheme(UnthemedFavoriteButton, 'FavoriteButton');
//# sourceMappingURL=FavoriteButton.js.map